/**
 *
 * @file 项目空间
 *
 **/

import { makeAutoObservable, flow } from 'mobx';
import { getProjectPermission } from '@/api/projectSpace';

class ProjectSpace {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    //  缓存权限
    catchPermission = {};

    catchRole = {};


    queryPermissions = flow(function* (projectId) {
        if (this.catchPermission[projectId]) return Promise.resolve();
        const { data } = yield getProjectPermission({ projectId });
        this.setPermission(projectId, data.power);
        this.setRole(projectId, data.role)
    });

    setPermission(key, val) {
        this.catchPermission[key] = val;
    }

    setRole(key, val){
        this.catchRole[key] = val; 
    }
}

export default new ProjectSpace();
